import { useParams } from 'next/navigation';
import { useEffect, useState } from 'react';
import { sdk } from 'sdk';
import { Token } from 'shared/types/Token';

const useCheckout = (cartIdProp?: string) => {
  const { slug } = useParams();
  const cartId = slug?.[0] === 'cart' ? slug?.[1] : (cartIdProp ?? '');
  const [session, setSession] = useState<Token>();
  const [isExpired, setIsExpired] = useState(false);

  useEffect(() => {
    void sdk.composableCommerce.cart.getCheckoutSessionToken({ cartId }).then((res) => {
      if (!res.isError) setSession(res.data);
      else setIsExpired(true);
    });
  }, [cartId]);

  return { session, isExpired };
};

export default useCheckout;
